import { storeRef } from "@/components/providers/StoreProvider"

export const getQueryStringSearchHotel = () => {
  const hotelState = storeRef.current?.getState().hotel
  const params = new URLSearchParams()

  params.set('adt', `${hotelState?.formSearch?.adults || 1}`)
  params.set('child', `${hotelState?.formSearch?.children || 0}`)
  params.set('room', `${hotelState?.formSearch?.roomsNum || 1}`)
  params.set('in', `${hotelState?.formSearch?.checkInDate}`)
  params.set('out', `${hotelState?.formSearch?.checkOutDate}`)
  params.set('loc', `${hotelState?.formSearch?.location?.id}`)
  params.set('type', `${hotelState?.formSearch?.location?.searchType}`)
  const childrenAges = hotelState?.formSearch?.childrenAges || []
  params.delete('children_ages')
  for (let i = 0; i < childrenAges.length; i++) {
    const childAge = childrenAges[i];
    params.append('children_ages', `${childAge}`) 
  }

  return params.toString()
}